import React, { useState } from "react";
import ScorePanel from "./ScorePanel";

export default function AnswerSheetCard({
  questions,
  answers,
  currentIndex,
  onJump,
  onReset,
  stats,
  isFlashcard,
  onFlashcardToggle,
}) {
  const [showScore, setShowScore] = useState(false);

  return (
    /* mobile: full-width below question; desktop (lg): fixed 208px sidebar */
    <div className="w-full lg:w-52 lg:shrink-0 flex flex-col gap-3">

      {/* Header */}
      <div className="flex items-center justify-between">
        <span className="text-sm font-semibold text-gray-800">答题卡</span>
        <button onClick={onReset} className="text-xs text-red-500 hover:text-red-600">
          重新练习
        </button>
      </div>

      {/* Grid
          mobile  (<lg): fill full width, auto-fill 2rem cells
          desktop (≥lg): 5 columns inside w-52
      */}
      <div className="bg-white border border-gray-200 rounded-xl p-3">
        <div className="flex items-center justify-between mb-2">
          <p className="text-xs text-gray-400 font-medium">单选题</p>
          <p className="text-xs text-gray-400">共 {questions.length} 题</p>
        </div>
        <div
          className="gap-1.5 max-h-[146px] pr-1"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, 2rem)",
            alignContent: "start",
            overflowY: "scroll",
          }}
        >
          {questions.map((q, idx) => {
            const userAnswer = answers[q.id];
            const answered = userAnswer !== undefined;
            const correct = answered && userAnswer === q.answer;
            const isActive = idx === currentIndex;

            let bg = "bg-gray-100 text-gray-500";
            if (answered) bg = correct ? "bg-green-500 text-white" : "bg-red-400 text-white";
            if (isActive && !answered) bg = "bg-indigo-100 text-indigo-700 ring-1 ring-indigo-400";

            return (
              <button
                key={q.id}
                onClick={() => onJump(idx)}
                className={`w-8 h-8 rounded-md text-xs font-semibold transition-colors ${bg}`}
              >
                {idx + 1}
              </button>
            );
          })}
        </div>
      </div>

      {/* Stats */}
      <div className="bg-white border border-gray-200 rounded-xl p-3 space-y-1.5">
        <div className="flex justify-between text-xs">
          <span className="text-gray-500">答对</span>
          <span className="font-semibold text-green-600">{stats.correct}题</span>
        </div>
        <div className="flex justify-between text-xs">
          <span className="text-gray-500">答错</span>
          <span className="font-semibold text-red-500">{stats.totalErrors}题</span>
        </div>
        <div className="flex justify-between text-xs">
          <span className="text-gray-500">正确率</span>
          <span className="font-semibold text-gray-700">{stats.rate}%</span>
        </div>
      </div>

      {/* 查看练习成绩 */}
      <button
        onClick={() => setShowScore((v) => !v)}
        className="w-full py-2 rounded-lg bg-indigo-500 text-white text-xs font-semibold hover:bg-indigo-600 transition-colors"
      >
        {showScore ? "收起成绩" : "查看练习成绩"}
      </button>

      {showScore && <ScorePanel questions={questions} answers={answers} />}

      {/* 背题模式 toggle */}
      <div className="flex items-center justify-between bg-white border border-gray-200 rounded-xl px-3 py-2">
        <span className="text-xs text-gray-600">背题模式</span>
        <button
          onClick={onFlashcardToggle}
          className={`relative w-10 h-5 rounded-full transition-colors ${
            isFlashcard ? "bg-indigo-500" : "bg-gray-200"
          }`}
        >
          <span
            className={`absolute top-0.5 w-4 h-4 rounded-full bg-white shadow transition-all ${
              isFlashcard ? "left-5" : "left-0.5"
            }`}
          />
        </button>
      </div>
    </div>
  );
}
